import {
  RU_MESSAGES,
  type LocaleMessages,
  type MessageKey,
  type MessageParams,
} from './messages.js';

export const SUPPORTED_LOCALES = [
  'ru',
  'en',
  'hy',
  'bg',
  'el',
  'ka',
  'he',
  'es',
  'it',
  'kk',
  'zh',
  'lt',
  'de',
  'pl',
  'pt',
  'tr',
  'uk',
  'fr',
  'cs',
  'ro',
  'lv',
] as const;

export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

declare global {
  interface Window {
    __plpLocales?: Partial<Record<SupportedLocale, LocaleMessages>>;
  }
}

const SUPPORTED = new Set<string>(SUPPORTED_LOCALES);
const LEGACY_ALIASES: Record<string, SupportedLocale> = {
  am: 'hy',
  ge: 'ka',
  kz: 'kk',
};

export function normalizeLocale(raw?: string | null): SupportedLocale {
  const normalized = (raw ?? '').trim().toLowerCase().replace(/_/g, '-');
  const base = normalized.split('-')[0] || 'ru';
  const aliased = LEGACY_ALIASES[base] ?? base;
  return SUPPORTED.has(aliased) ? (aliased as SupportedLocale) : 'ru';
}

export function currentLocale(): SupportedLocale {
  return normalizeLocale(document.documentElement.lang);
}

export function t(key: MessageKey, params: MessageParams = {}): string {
  const locale = currentLocale();
  const message = window.__plpLocales?.[locale]?.[key] ?? RU_MESSAGES[key];
  return message.replace(/\{([a-zA-Z0-9_]+)\}/g, (match, name: string) => {
    const value = params[name];
    return value === undefined ? match : String(value);
  });
}

export function mapSdkLocale(provider: 'yandex' | 'google'): string {
  const locale = currentLocale();
  if (provider === 'google') return locale;
  if (locale === 'ru') return 'ru_RU';
  if (locale === 'tr') return 'tr_TR';
  if (locale === 'uk') return 'uk_UA';
  return 'en_US';
}
